import React from 'react';
import type { MouseEventHandler, FC } from 'react';
import { useHistory } from 'react-router';

import { TextButton } from '@clutter/clean';

import { FlashKind } from '@shared/types/flash';

import { Status, useRenewalRejectMutation } from '@portal/schema';

export const RenewalRejectButton: FC = () => {
  const history = useHistory();
  const [execute, { loading }] = useRenewalRejectMutation();

  const onClick: MouseEventHandler = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (loading) return;
    const response = await execute();
    if (response.data?.result?.status !== Status.Ok) return;

    history.push('/account', {
      flash: {
        kind: FlashKind.Info,
        message: 'Your plan is unchanged.',
      },
    });
  };
  return (
    <div className="text-center">
      <TextButton kind="destructive" onClick={onClick}>
        Keep My Current plan
      </TextButton>
    </div>
  );
};
